<div class="dialog-wrap">
  <h1 *ngIf="data.heading">{{data.heading}}</h1>
  <h1 *ngIf="data.heading2">{{data.heading2}}</h1>
  <img [src]="iconString" alt="Icon" class="icon" *ngIf="iconString">
  <p *ngIf="data.content1">{{data.content1}}</p>
  <p *ngIf="data.content2">{{data.content2}}</p>
  <!-- <img class="error-info-icon" alt="error-information"
  src="../../../assets/svg/error-info.png"
  (click)="toggleError()"
/> -->
<p *ngIf="data.errorText" class="error-link" (click)="toggleError()">{{more}}</p>

  <p *ngIf="showError" class="error-text">{{data.errorText}}</p>
  <!-- <p *ngIf="showError" class="error-text">Internal Server Error</p> -->

  <div class="upload-box" *ngIf="data.showFileUpload">
    <input type="file" hidden #docFileInput [accept]="data.fileAccept || '.pdf'"
      (change)="onFileSelected($event)">
    <button type="button" class="dialog-btn upload-btn" (click)="docFileInput.click()">
      <svg class="upload-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M12 16V4"></path>
        <path d="M7.5 8.5 12 4l4.5 4.5"></path>
        <path d="M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3"></path>
      </svg>
      <span>{{ selectedFileName ? 'CHANGE FILE' : 'UPLOAD FILE' }}</span>
    </button>
    <p class="file-name" *ngIf="selectedFileName"><span class="file-chip">&#10003; {{selectedFileName}}</span></p>
    <p class="upload-note" *ngIf="data.uploadNote">{{data.uploadNote}}</p>
    <p class="error-text" *ngIf="fileError">{{fileError}}</p>
  </div>

  <br>
  <div class="flex-gap btn-row">
    <button *ngIf="data.button1Text" (click)="onYes()" class="dialog-btn"
      [disabled]="isPrimaryDisabled()">{{data.button1Text}}</button>
    <button *ngIf="data.button2Text" (click)="onNo()" class="dialog-btn">{{data.button2Text}}</button>
  </div>
  <div class="ring" *ngIf="data.showBuffering">Loading
    <span></span>
  </div>
  <mat-progress-bar *ngIf="data.showWaiting" mode="buffer"> Please Wait</mat-progress-bar>

</div>
